var _link, _link2, _style, _style2, _style3, _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDthCoverPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: .39px;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6, .cls-10, .cls-8 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-5, .cls-10 {\n        stroke: #000;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke-width: .65px;\n      }\n\n      .cls-3, .cls-4, .cls-7, .cls-9 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-7, .cls-9 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-8 {\n        stroke: #f06d27;\n      }\n\n      .cls-4 {\n        stroke: #752e1c;\n      }\n\n      .cls-4, .cls-5, .cls-10, .cls-9 {\n        stroke-width: .44px;\n      }\n\n      .cls-12 {\n        fill: #f8c101;\n      }\n\n      .cls-13 {\n        fill: #f9eacf;\n      }\n\n      .cls-14, .cls-10 {\n        fill: #f4f4f4;\n      }\n\n      .cls-15 {\n        fill: #f26c26;\n      }\n\n      .cls-16 {\n        fill: #ffb599;\n      }\n\n      .cls-17 {\n        fill: #752e1c;\n      }\n\n      .cls-18 {\n        fill: #d17e63;\n      }\n\n      .cls-19 {\n        fill: #c7c03a;\n      }\n\n      .cls-20 {\n        fill: #95c939;\n      }\n\n      .cls-21 {\n        fill: #47976c;\n      }\n\n      .cls-6 {\n        stroke: #252525;\n        stroke-width: .42px;\n      }\n\n      .cls-7 {\n        stroke: #cb3e4e;\n        stroke-width: .57px;\n      }\n\n      .cls-8 {\n        stroke-width: .59px;\n      }\n\n      .cls-9 {\n        stroke: #ccba9b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 155.38,
    y: 88.86,
    width: 8.63,
    height: 14.19,
    rx: 4.31,
    ry: 4.31
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 47.52,
    y1: 226.9,
    x2: 252.48,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 108.93,
    y1: 91.64,
    x2: 108.93,
    y2: 111.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 81.2,
    y1: 91.64,
    x2: 81.2,
    y2: 111.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 75.99,
    y: 215.05,
    width: 37.85,
    height: 11.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 74.41,
    y1: 91.86,
    x2: 115.4,
    y2: 91.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 159.33,
    cy: 78.12,
    rx: 5.12,
    ry: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M199.42,112.98l2.38-1.41c.42-.25,.9-.4,1.4-.43l9.68-.56c.17,0,.33,.09,.4,.24h0c.09,.2,0,.44-.19,.54l-3.57,1.78,2.92,.11c.26,.01,.52-.07,.72-.23l4.38-3.36c.26-.2,.63-.18,.87,.06h0c.25,.25,.26,.65,.02,.91l-3.87,4.26c-.62,.68-1.49,1.07-2.41,1.08l-7.3,.07c-.5,0-.99,.18-1.38,.49l-2.08,1.67-1.96-5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M131.01,146.91l-6.17,9.33c-.27,.42-.15,.98,.28,1.23l.11,.06c.4,.24,.91,.13,1.17-.26l2.06-3.02-1.99,4.26c-.18,.38-.06,.84,.28,1.08l.53,.38c.46,.33,1.1,.14,1.31-.38l1.81-4.35-1.61,4.59c-.15,.44,.06,.91,.48,1.09l.28,.12c.46,.2,.99-.04,1.16-.51l1.57-4.4-1.11,4.46c-.11,.45,.15,.91,.6,1.05l.05,.02c.47,.14,.96-.13,1.09-.59l1.32-4.55-.9,4.5c-.1,.49,.23,.96,.73,1.04h0c.46,.07,.89-.23,.98-.69l2.8-13.38-5.91-2.75-.92,1.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "129.78 148.81 128.33 150.94 136.96 152.22 137.2 151.01 129.78 148.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "152.19 118.25 149.98 127.96 171.93 128.09 170.49 118.25 152.19 118.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "152.19 118.35 150.75 124.69 171.12 122.63 170.49 118.35 152.19 118.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "174.36 207.54 174.36 221.34 161.64 221.34 161.64 208.11 174.36 207.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "174.36 210.44 174.36 213.67 161.64 215.99 161.64 211.01 174.36 210.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "143.27 207.41 143.27 221.21 155.98 221.21 155.98 207.99 143.27 207.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "143.27 210.65 143.27 212.47 155.98 215.82 155.98 211.22 143.27 210.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M150.27,125.12h21.59l2.05,5.11c1.86,4.66,2.99,9.57,3.34,14.57l4.84,68.86h-21.21l.26-67.34-4.6,67.34-22.49-2.04,11.37-70.83c.51-3.2,1.35-6.34,2.49-9.38l2.37-6.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 153.34,
    y1: 132.28,
    x2: 149.76,
    y2: 139.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 168.93,
    y1: 132.28,
    x2: 172.76,
    y2: 139.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M161.07,217.57s3.26,1.66,6.93,1.21,6.36-2.36,6.36-2.36c0,0,3.58,4.22,9.84,4.22,5.37,0,4.73,6.26,0,6.26h-21.33s-1.8-.06-1.8-1.66v-7.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 176.53,
    y1: 221.66,
    x2: 178.93,
    y2: 219.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 174.93,
    y1: 220.96,
    x2: 177.73,
    y2: 218.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 173.14,
    y1: 219.71,
    x2: 175.95,
    y2: 217.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M156.56,217.57s-3.26,1.66-6.93,1.21-6.36-2.36-6.36-2.36c0,0-3.58,4.22-9.84,4.22-5.37,0-4.73,6.26,0,6.26h21.33s1.8-.06,1.8-1.66v-7.67Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 141.09,
    y1: 221.66,
    x2: 138.69,
    y2: 219.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 142.69,
    y1: 220.96,
    x2: 139.89,
    y2: 218.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 155.38,
    y: 89.31,
    width: 8.63,
    height: 14.19,
    rx: 4.31,
    ry: 4.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 144.48,
    y1: 219.71,
    x2: 141.67,
    y2: 217.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M154.49,97.65s2.43,2.04,5.43,1.73c3-.32,4.86-2.11,4.86-2.11,0,0,8.24-.32,12.78,4.66,4.54,4.98,8.31,15.01,8.31,15.01l14.25-6.77,4.22,11.69-16.29,8.43s-7.73,2.68-10.93-3.64-5.24-10.86-5.24-10.86l-.06,7.48-21.28-.19,.32-7.67s-.19,8.82-3.83,18.21c-3.64,9.39-7.92,18.72-7.92,18.72l-12.52-4.15,7.92-16.61,6.77-21.85s1.15-7.29,8.31-10.22c.6-.25,4.92-1.85,4.92-1.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M165.22,89.31c0,3.98-2.6,7.49-5.72,7.49-2.5,0-5.48-3.07-5.48-7.49,0-3.98,2.01-7.2,5.48-7.2s5.72,3.22,5.72,7.2Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 159.5,
    cy: 88.27,
    rx: 6.29,
    ry: 7.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 166.36,
    cy: 89.48,
    rx: 1.78,
    ry: 2.04,
    transform: "translate(-16.62 42.57) rotate(-13.9)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 165.99,
    y1: 89.75,
    x2: 166.98,
    y2: 89.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 156.26,
    y1: 87.43,
    x2: 157.96,
    y2: 87.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.06,91.66c-.25,.76-1.25,1.35-2.24,1.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 162.61,
    y1: 87.43,
    x2: 160.92,
    y2: 87.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 152.89,
    cy: 89.48,
    rx: 2.04,
    ry: 1.78,
    transform: "translate(29.31 216.4) rotate(-76.1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 153.21,
    y1: 89.8,
    x2: 152.38,
    y2: 89.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M154.15,86.98c.33-.36,.51-.83,.69-1.28,.2-.51,.4-1.02,.6-1.53-.11,.73-.21,1.47-.32,2.2,1.24-.38,2.53-.64,3.82-.77l.29-1.97,.33,1.81c.8-.06,1.6-.04,2.39,.06,.05-.48,.08-.96,.07-1.44,.12,.46,.25,.93,.37,1.39,.03,.11,.06,.21,.12,.3,.07,.1,.18,.17,.28,.24,.98,.64,2.71,1.65,3.19,1.48,0-1.12-.18-2.06-.55-3.12-.55-1.58-1.84-2.98-3.39-3.62-1.75-.72-3.86-.9-5.6-.05-2.23,1.09-3.66,3.91-3.57,6.38,.03,.79,.93,.27,1.26-.09Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 58.64,
    y: 111.01,
    width: 72.4,
    height: 104.36,
    rx: 13.77,
    ry: 13.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 58.64,
    y1: 154.03,
    x2: 131.04,
    y2: 154.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 58.64,
    y1: 171.06,
    x2: 131.04,
    y2: 171.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 206.61,
    cy: 88.27,
    r: 15.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.83,
    y1: 81.32,
    x2: 211.38,
    y2: 81.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201.83,
    y1: 85.57,
    x2: 211.38,
    y2: 85.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M205.17,81.32c1.72,0,3.98,1.12,3.98,4.25,0,5.42-7.09,4.09-7.09,4.09l6.54,6.74"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M230.24,156.04s8.17,6.88,2.69,16.83c-4.22,7.67-12.77,6.05-12.77,6.05,0,0-7.79-5.64-4.06-15.09s14.14-7.79,14.14-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M257.14,181.94s-4.03,7.15-12.32,4.43c-6.39-2.09-6.39-8.78-6.39-8.78,0,0,3.14-6.69,10.81-5.22s7.9,9.56,7.9,9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M204.6,183.65s-4.45,6.61-12.24,3.32c-6.01-2.54-5.48-9.02-5.48-9.02,0,0,3.56-6.23,10.84-4.2,7.28,2.03,6.88,9.9,6.88,9.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M213.44,177.01s5.99,1.23,5.93,7.72c-.05,5-4.8,6.52-4.8,6.52,0,0-5.46-.7-6.15-6.47-.68-5.76,5.02-7.77,5.02-7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M230.71,186.78s1.22,4.42-3.14,6.59c-3.36,1.67-6-.98-6-.98,0,0-1.39-3.89,2.23-6.31s6.9,.71,6.9,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M244.76,200.24s-3.57,3.89-8.34,.96c-3.68-2.26-2.69-6.45-2.69-6.45,0,0,2.95-3.73,7.52-1.67,4.57,2.05,3.52,7.16,3.52,7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M233.69,199.87s-.04,2.65-2.81,3.15c-2.14,.39-3.17-1.52-3.17-1.52,0,0-.14-2.39,2.26-3.14,2.4-.76,3.72,1.51,3.72,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M203.51,195.53s-1.49,5.06-7.07,4.54c-4.3-.4-5.26-4.6-5.26-4.6,0,0,1-4.65,6.01-4.81,5.01-.17,6.32,4.88,6.32,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M222.15,173.35s-5.47,18.76-4.81,35.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.44,179.06s-21.89-9.35-29.02,29.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.43,196.58s-12.54-7.88-17.52,11.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M230.28,200.64s-6.74,1.83-7.85,7.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M196.45,195s16.63-1.65,18.64,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.37,179.58s18.57,.09,20.98,30.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.95,188.97s-7.86,1.39-6.95,18.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.87,182.82s3.49,27.03,4.06,29.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "204.6 206.11 232.1 206.11 226.09 226.92 210.05 226.92 204.6 206.11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDthCoverPage);
export default __webpack_public_path__ + "static/media/DthCoverPage.9412bd7d37b2242c30130887e247ac9f.svg";
export { ForwardRef as ReactComponent };